var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.09615 13.8547V11.8101C6.09614 11.292 6.51744 10.8711 7.03928 10.8678H8.9554C9.47957 10.8678 9.9045 11.2897 9.9045 11.8101V13.8487C9.90449 14.2981 10.2697 14.6633 10.7223 14.6666H12.0295C12.6401 14.6681 13.2262 14.4284 13.6584 14.0004C14.0907 13.5723 14.3337 12.9911 14.3337 12.3849V6.57715C14.3337 6.08751 14.115 5.62306 13.7367 5.30892L9.29564 1.78276C8.51933 1.166 7.41057 1.18592 6.65725 1.83017L2.31167 5.30892C1.91549 5.6138 1.67869 6.07963 1.66699 6.57715V12.379C1.66699 13.6424 2.69858 14.6666 3.97111 14.6666H5.24852C5.46644 14.6681 5.67598 14.5833 5.83064 14.4309C5.9853 14.2784 6.07228 14.071 6.07227 13.8547H6.09615Z",
    fill: "#507AF3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.a1345a38.svg";
export { ForwardRef as ReactComponent };